/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { Field, FieldProps, FormikValues } from 'formik';
import Error from './Error';
import TooltipComponent from '../../TooltipComponent';
import SearchService from '../../../Services/SearchService';

interface IChipSelectOption {
  item: string;
  value: string | number;
  disabled?: boolean;
  groupName?: string;
  passed?: boolean;
  popup?: null | string;
  vehicles?: string;
  total?: string;
  customerLabel?: string;
}

interface IChipSelectProps {
  id: string;
  name: string;
  label: string;
  options: IChipSelectOption[];
  searchPlaceholder: string;
  selectButton: string;
  resetButton: string;
  placeholder?: string;
  required?: boolean;
  onChangeCallback?: (number: number, values: (string | number)[]) => void;
  showDetail?: () => void;
  showPartialDetail?: (id: string) => void;
  itemsNumber?: number;
  searchTooltip?: string;
  selectButtonTooltip?: string;
  resetButtonTooltip?: string;
  tooltip?: string;
  warningMessage?: string;
  bossCheckbox?: string;
  disabled?: boolean;
}

const ChipSelect: React.FC<IChipSelectProps> = (props) => {
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = React.useState<boolean>(false);
  const [selectedItems, setSelectedItems] = React.useState<(string | number)[]>([]);
  const [searchString, setSearchString] = React.useState<string>('');
  const [isTooltipDisabled, setIsTooltipDisabled] = React.useState<boolean>(false);
  const [optionsFromSearch, setOptionsFromSearch] = React.useState<IChipSelectOption[]>(
    props.options
  );

  const handleClickOutside = React.useCallback(
    (event: any) => {
      if (props.disabled) {
        return;
      }
      const id = event.target.parentElement.id;
      const idWithoutParent = event.target.id;

      let checkboxId = '';
      const idData = id.split('-');
      if (idData.length > 0) {
        checkboxId = idData[0];
      }

      if (
        id === props.id ||
        id === 'chooseAllLabel' ||
        id === 'boxCheckboxLabel' ||
        id === `chip-select-${props.id}` ||
        id === `selectMultipleSearch-${props.id}` ||
        checkboxId === `${props.id}_selectCheckbox` ||
        id === `multipleCheckboxes-${props.id}` ||
        id === `icon-${props.id}` ||
        id === `choose-${props.id}` ||
        idWithoutParent === `title-${props.id}` ||
        idWithoutParent === `footer-${props.id}`
      ) {
        if (!isDropdownMenuOpen) {
          setIsDropdownMenuOpen(false);
        } else {
          setIsDropdownMenuOpen(true);
        }
        if (id === `choose-${props.id}` || id === props.id) {
          setIsDropdownMenuOpen(!isDropdownMenuOpen);
        }
      } else {
        setIsDropdownMenuOpen(false);
      }
    },
    [isDropdownMenuOpen, props.id]
  );

  const handleEscapeKey = React.useCallback(
    (event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        if (isDropdownMenuOpen) {
          setIsDropdownMenuOpen(false);
        }
      }
    },
    [isDropdownMenuOpen]
  );

  React.useEffect(() => {
    // semi checkbox
    const checkbox: any = document.getElementById('chipSelectCheckboxIndeterminate');
    if (checkbox) {
      if (selectedItems.length === 0) {
        checkbox.indeterminate = false;
        checkbox.checked = false;
      } else if (optionsFromSearch.length === selectedItems.length) {
        checkbox.indeterminate = false;
        checkbox.checked = true;
      } else {
        checkbox.indeterminate = true;
      }
    }
  }, [
    selectedItems && selectedItems.length,
    isDropdownMenuOpen,
    optionsFromSearch && optionsFromSearch.length,
  ]);

  // React.useEffect(() => {
  //   window.addEventListener('click', handleClickOutside);
  //   window.addEventListener('keydown', handleEscapeKey);
  //   return () => {
  //     window.removeEventListener('click', handleClickOutside);
  //     window.removeEventListener('keydown', handleEscapeKey);
  //   };
  // });

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    setSearchString(value);

    let filteredGroups: IChipSelectOption[] = [];
    if (props.options) {
      const filtered: any = Object.values(props.options).filter(
        (option: any) =>
          SearchService.removeAccent(option.item.toLowerCase()).includes(
            SearchService.removeAccent(value.toLowerCase())
          ) ||
          (option.label &&
            SearchService.removeAccent(option.label.toLowerCase()).includes(
              SearchService.removeAccent(value.toLowerCase())
            ))
      );
      if (filtered.length > 0) {
        filteredGroups = filtered;
      }
    }
    if (value) {
      setOptionsFromSearch(filteredGroups);
    } else {
      setOptionsFromSearch(props.options);
    }
  };

  const handleDetail = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
    if (props.showDetail) {
      props.showDetail();
    } else {
      setIsDropdownMenuOpen(!isDropdownMenuOpen);
    }
  };

  const handlePartialDetail = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const id = event.currentTarget.getAttribute('data-id');
    event.preventDefault();
    event.stopPropagation();
    if (props.showPartialDetail) {
      props.showPartialDetail(String(id));
    } else {
      if (props.disabled) {
        return;
      }
      setIsDropdownMenuOpen(!isDropdownMenuOpen);
    }
  };

  return (
    <Field name={props.name} id={props.id}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched, setFieldError },
        meta: { error, touched },
      }: FieldProps) => {
        React.useEffect(() => {
          if (value && Object.keys(value).length > 0) {
            setSelectedItems(value);
          } else {
            setSelectedItems([]);
          }
        }, []);

        React.useEffect(() => {
          if (value) {
            setSelectedItems(value);
          }
        }, [value]);

        React.useEffect(() => {
          setOptionsFromSearch(props.options);
          if (!value && selectedItems.length !== 0) {
            setSelectedItems([]);
          }
        }, [props.options]);

        const handleShowDropdownMenu = (
          event:
            | React.MouseEvent<HTMLLabelElement, MouseEvent>
            | React.MouseEvent<HTMLDivElement, MouseEvent>
        ): boolean => {
          event.preventDefault();
          if (props.disabled) {
            return false;
          }
          if (isDropdownMenuOpen) {
            setFieldTouched(props.name);
          }
          setIsDropdownMenuOpen(!isDropdownMenuOpen);
          return true;
        };

        const handleReset = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          event.preventDefault();
          setFieldValue(props.name, []);
          setIsDropdownMenuOpen(false);
        };

        const handleApply = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          event.preventDefault();

          setFieldValue(props.name, selectedItems);
          setIsDropdownMenuOpen(false);

          if (props.onChangeCallback) {
            props.onChangeCallback(selectedItems.length, selectedItems);
          }
        };

        const handleSelectItem = (
          event:
            | React.MouseEvent<HTMLLabelElement, MouseEvent>
            | React.ChangeEvent<HTMLInputElement>
        ) => {
          event.preventDefault();
          const dataValue = event.currentTarget.getAttribute('data-value');
          const disabled = event.currentTarget.getAttribute('data-disabled');

          if (disabled === 'true') {
            return;
          }

          if (dataValue) {
            if (!selectedItems.includes(dataValue)) {
              const newSelectedItems: (string | number)[] = [...selectedItems, dataValue];
              setSelectedItems(newSelectedItems);
            } else {
              const newSelectedItems = selectedItems.filter(
                (item: string | number) => item !== dataValue
              );
              setSelectedItems(newSelectedItems);
            }
          }
        };

        const handleRemoveItem = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          event.preventDefault();
          event.stopPropagation();
          if (props.disabled) {
            return;
          }
          const selectedValue = event.currentTarget.getAttribute('data-value');
          if (selectedValue) {
            const newSelectedItems = selectedItems.filter(
              (item: string | number) => item !== selectedValue
            );
            const countItems = newSelectedItems.length;
            if (countItems === 0) {
              setFieldTouched(props.name);
              setSelectedItems(newSelectedItems);
              setFieldValue(props.name, []);
            } else {
              setSelectedItems(newSelectedItems);
              setFieldValue(props.name, newSelectedItems);
            }
          }
        };

        const getSelectedFieldValues = (fieldValue: FormikValues, options: IChipSelectOption[]) => {
          const selectedFieldValueItems: IChipSelectOption[] = [];
          if (fieldValue) {
            if (fieldValue.length > 0 && options) {
              Object.values(options)
                .filter((optionItem: any) => fieldValue.includes(String(optionItem.value)))
                .forEach((optionItem: any) => {
                  selectedFieldValueItems.push(optionItem);
                });
            }
            return selectedFieldValueItems;
          }
          return [];
        };

        const selectedFieldValueItems: IChipSelectOption[] = getSelectedFieldValues(
          value,
          props.options
        );

        const getErrorItems = () => {
          let isError = false;
          const numberOfseenItems = props.itemsNumber || 2;
          Object.values(selectedFieldValueItems).forEach((item: any, key: number) => {
            if (key > numberOfseenItems - 1) {
              if (item.passed === false) {
                isError = true;
              }
            }
          });
          return isError;
        };

        const handleOnMouseEnter = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          setIsTooltipDisabled(true);
        };

        const handleOnMouseLeave = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          setIsTooltipDisabled(false);
        };

        const handleAllChoose = (e: any) => {
          if (e.target.checked) {
            const options = optionsFromSearch.map((item: any) => {
              return String(item.value);
            });
            setSelectedItems(options);
          } else {
            setSelectedItems([]);
          }
        };

        return (
          <div
            className={`group-chip-select-component form-group ${
              props.warningMessage && 'form-group-warning'
            } ${touched && error && 'form-group-error'}`}
          >
            <div>
              <label className="d-block form-label" onClick={handleShowDropdownMenu}>
                {props.required && <span className="text-danger required-field-info">*</span>}
                {props.label}
              </label>
              <div className="d-block">
                <div id={props.id} className={`b-dropdown ${isDropdownMenuOpen ? 'open' : ''}`}>
                  <div
                    id={`choose-${props.id}`}
                    className="form-control-labels"
                    onClick={handleShowDropdownMenu}
                    data-cy={`chipSelect-${props.name}`}
                    title={props.tooltip && !isTooltipDisabled ? props.tooltip : ''}
                    style={props.disabled ? { color: '#bbbbbb' } : {}}
                  >
                    {selectedFieldValueItems.length > 0 ? (
                      <>
                        {(selectedFieldValueItems.length > 0 ||
                          selectedFieldValueItems.length < (props.itemsNumber || 2)) &&
                          selectedFieldValueItems
                            .filter(
                              (_optionItem: IChipSelectOption, index: number) =>
                                index < (props.itemsNumber || 2)
                            )
                            .map((optionItem: IChipSelectOption, indexMap: number) =>
                              optionItem.popup ? (
                                <TooltipComponent
                                  id={props.id}
                                  firstItems={true}
                                  positionLeft={true}
                                  overlay={<div style={{ color: '#fff' }}>{optionItem.popup}</div>}
                                  key={indexMap}
                                  data-cy={`tooltip-${props.name}-${optionItem.popup}`}
                                >
                                  <div
                                    onClick={handlePartialDetail}
                                    onMouseEnter={handleOnMouseEnter}
                                    onMouseLeave={handleOnMouseLeave}
                                    data-id={optionItem.value}
                                    className={`label ${
                                      optionItem.passed === false ? 'label-primary' : ''
                                    }`}
                                    key={`label-${optionItem.item}`}
                                    data-cy={`chips-false-${props.name}-${optionItem.value}`}
                                  >
                                    {optionItem.passed === false && (
                                      <span>
                                        <i
                                          id={`icon-${optionItem.item}`}
                                          className="cmd-icon cmd-icon-exclamation"
                                        />
                                        &nbsp;&nbsp;&nbsp;
                                      </span>
                                    )}
                                    {`${optionItem.item} `}
                                    <a
                                      className="label-action cmd-icon cmd-icon-remove-sm"
                                      data-value={optionItem.value}
                                      data-group={optionItem.groupName}
                                      onClick={handleRemoveItem}
                                      data-cy={`remove-false-chips-${props.name}-${optionItem.value}`}
                                    />
                                  </div>
                                </TooltipComponent>
                              ) : (
                                <div
                                  onClick={handlePartialDetail}
                                  data-id={optionItem.value}
                                  className={`label ${
                                    optionItem.passed === false ? 'label-primary' : ''
                                  }`}
                                  key={`label-${optionItem.item}`}
                                  style={props.disabled ? { opacity: 0.5 } : {}}
                                  data-cy={`chips-${props.name}-${optionItem.value}`}
                                >
                                  {optionItem.passed === false && (
                                    <span>
                                      <i
                                        id={`icon-${optionItem.item}`}
                                        className="cmd-icon cmd-icon-exclamation text-white"
                                      />
                                      &nbsp;&nbsp;&nbsp;
                                    </span>
                                  )}
                                  {`${optionItem.item} `}
                                  <a
                                    className="label-action cmd-icon cmd-icon-remove-sm"
                                    data-value={optionItem.value}
                                    data-group={optionItem.groupName}
                                    onClick={handleRemoveItem}
                                    data-cy={`remove-chips-${props.name}-${optionItem.value}`}
                                  />
                                </div>
                              )
                            )}
                        {selectedFieldValueItems.length > (props.itemsNumber || 2) && (
                          <div
                            onClick={handleDetail}
                            className={`label ${getErrorItems() ? 'label-primary' : ''}`}
                          >
                            {getErrorItems() && (
                              <span>
                                <i
                                  id="main-icon"
                                  className="cmd-icon cmd-icon-exclamation text-white"
                                  data-cy={`exlamation-icon-${props.name}`}
                                />
                                &nbsp;&nbsp;&nbsp;
                              </span>
                            )}
                            +{selectedFieldValueItems.length - (props.itemsNumber || 2)}
                          </div>
                        )}
                      </>
                    ) : (
                      <span>{props.placeholder}</span>
                    )}
                  </div>
                  {isDropdownMenuOpen && (
                    <div className="b-dropdown__content">
                      <div id={`chip-select-${props.id}`} className="b-dropdown__header">
                        <input
                          type="text"
                          className="form-control"
                          onChange={handleSearch}
                          value={searchString}
                          placeholder={props.searchPlaceholder}
                          autoFocus={true}
                          data-cy={`chip-select-search-${props.id}`}
                          title={props.searchTooltip || ''}
                        />
                      </div>
                      {props.bossCheckbox && (
                        <div id={`chip-select-${props.id}`} className="b-dropdown__header">
                          <div className="e-checkbox">
                            <label id="chooseAllLabel">
                              <input
                                onChange={handleAllChoose}
                                type="checkbox"
                                className="js-checkbox-indeterminate"
                                id="chipSelectCheckboxIndeterminate"
                              />
                              <span style={{ fontSize: '13px' }} id="boxCheckboxLabel">
                                {' '}
                                <strong>{props.bossCheckbox}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                      <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                        <ul id={`multipleCheckboxes-${props.id}`} className="b-dropdown__list">
                          {Object.values(optionsFromSearch).map((option: any, index: number) => (
                            <li key={`${option.item}-${index}`}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div className="e-checkbox" style={{ flex: '1' }}>
                                  <label
                                    onClick={handleSelectItem}
                                    id={`${props.id}_selectCheckbox`}
                                    data-cy={`group-select-multiple-label-${option.value}`}
                                    data-value={option.value}
                                    data-disabled={option.disabled}
                                  >
                                    <input
                                      type="checkbox"
                                      value={option.value}
                                      disabled={option.disabled || false}
                                      checked={
                                        selectedItems
                                          ? selectedItems.includes(String(option.value))
                                          : false
                                      }
                                      data-value={option.value}
                                      onChange={handleSelectItem}
                                      data-cy={`checkbox-${props.name}-${option.value}`}
                                    />
                                    <span id={props.id}>{option.item}</span>
                                  </label>
                                  {Number(option.vehicles) > -1 && Number(option.total) > -1 ? (
                                    <span
                                      style={option.disabled ? { color: '#a6a6a6' } : { color: '' }}
                                      data-cy={`information-${props.name}-${option.value}`}
                                    >
                                      ({option.vehicles}/{option.total})&nbsp;
                                    </span>
                                  ) : (
                                    <span />
                                  )}
                                  {option.passed === false && (
                                    <i
                                      id={`icon-${props.id}`}
                                      className="cmd-icon cmd-icon-exclamation text-primary"
                                      data-cy={`exlamation-icon-${props.name}`}
                                    />
                                  )}
                                </div>{' '}
                                <div style={{ justifyContent: 'flex-end' }}>
                                  {option.customerLabel && option.customerLabel}
                                  {option.label && !option.customerLabel && option.label}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div id={`footer-${props.id}`} className="b-dropdown__footer">
                        <a
                          id={`reset-${props.id}`}
                          data-cy={`reset-${props.id}`}
                          href="#"
                          className="e-button"
                          onClick={handleReset}
                          title={props.resetButtonTooltip || ''}
                        >
                          {props.resetButton}
                        </a>
                        <a
                          id={`apply-${props.id}`}
                          data-cy={`apply-${props.id}`}
                          href="#"
                          className="e-button e-button--gray"
                          onClick={handleApply}
                          title={props.selectButtonTooltip || ''}
                        >
                          {props.selectButton}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                {touched && error && <Error message={error} newStyle={true} />}
                {props.warningMessage && <Error message={props.warningMessage} newStyle={true} />}
              </div>
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export default ChipSelect;
